import { useEffect, useState } from 'react';
import TransferConversationForm from '../shared/TransferConversationForm/TransferConversationForm';
import { IBrokerConnectionActiveConversationsData } from '../../model/brokerConnections/IBrokerConnectionActiveConversationsData';
import { fetchActiveConversation } from '../../store/features/activeConversations/activeConversationsAPI';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { makeStyles, Spinner, Text, tokens } from '@fluentui/react-components';
import { app } from '@microsoft/teams-js';

const useStyles = makeStyles({
    root: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        padding: '1.5rem',
    },
    errorMsg: {
        color: tokens.colorStatusDangerForeground1,
    },
    scheduledMessage: {
        color: tokens.colorStatusSuccessForeground1,
    },
    spinner: {
        width: '100%',
    },
});

type PageStatus = 'loading' | 'idle' | 'scheduled';

const Content: React.FC = () => {
    const { connectionId } = useParams();

    const { t } = useTranslation();
    const styles = useStyles();

    const [data, setData] =
        useState<IBrokerConnectionActiveConversationsData | null>();
    const [status, setStatus] = useState<PageStatus>('loading');
    const [errorMsg, setErrorMsg] = useState('');

    useEffect(() => {
        app.notifySuccess();
    }, []);

    useEffect(() => {
        if (!connectionId) {
            setStatus('idle');
            setErrorMsg(t('TransferConversation_Error_NotFound'));
            return;
        }

        setStatus('loading');

        fetchActiveConversation(connectionId).then((x) => {
            setStatus('idle');

            if (!x) {
                setErrorMsg(t('TransferConversation_Error_NotFound'));
                return;
            }

            if (x.isTransferred) {
                setStatus('scheduled');
                return;
            }

            setData(x);
        });
    }, [connectionId, t]);

    console.log(status);

    if (status === 'loading') {
        return <Spinner className={styles.spinner} />;
    }

    if (status === 'scheduled') {
        return (
            <Text className={styles.scheduledMessage}>
                {t('TransferConversation_TransferScheduled')}
            </Text>
        );
    }

    return !errorMsg && data ? (
        <TransferConversationForm
            conversationData={data}
            onSuccess={() => setStatus('scheduled')}
        />
    ) : (
        <Text className={styles.errorMsg}></Text>
    );
};

const TransferConversationPage: React.FC = () => {
    const styles = useStyles();

    return (
        <div className={styles.root}>
            <Content />
        </div>
    );
};

export default TransferConversationPage;
